import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get('admin/master/season/page', params)
const getDetail = (id) => get(`admin/master/season/${id}`)
const putData = params => put(`admin/master/season/${params.id}`, params)
const postData = params => post(`admin/master/season`, params)
const getList = () => get(`admin/master/season/list`)


const SeasonAPI = {
  getListPage,
  getDetail,
  postData,
  putData,
  getList
}

export default SeasonAPI